import type { JSX } from 'react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useActiveOrganization } from '@/features/organization/active-organization-context';

/**
 * Shown only when the authenticated user has more than one active
 * organization membership and no valid stored selection (ADR-026
 * Addendum, AO-5). The backend does not expose an organization display
 * name to a non-admin member (`organizations:read` is Organization
 * Admin/Super Admin only) - this shows the role name and the
 * organization id, not a fabricated name, per the addendum's own
 * documented limitation.
 */
export function SelectOrganizationPage(): JSX.Element {
  const { memberships, select } = useActiveOrganization();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Pilih Organisasi</CardTitle>
          <CardDescription>
            Akun Anda terhubung dengan lebih dari satu organisasi. Pilih salah satu untuk
            melanjutkan.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          {memberships.map((membership) => (
            <Button
              key={membership.organizationId}
              type="button"
              variant="outline"
              className="h-auto justify-between gap-3 py-3"
              onClick={() => {
                select(membership.organizationId);
              }}
            >
              <span className="font-medium">{membership.roleName}</span>
              <span className="truncate text-xs text-muted-foreground">
                {membership.organizationId}
              </span>
            </Button>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
